export const SKELETON_SIZES = [25, 40, 20, 35, 12, 30, 38, 22, 28];
